module.exports = __webpack_public_path__ + "static/casque3-d283518377c470e5bf109b47dfae00ca.jpg";